<div class="picture-strip">
  @if (canScrollLeft) {
    <button
      type="button"
      class="picture-strip__arrow picture-strip__arrow--left"
      (click)="scroll('left')"
      aria-label="Précédent"
    >
      <i class="bi bi-chevron-left"></i>
    </button>
  }

  <div class="picture-strip__track" #track (scroll)="updateArrows()">
    @for (picture of pictures; track $index) {
      <div class="picture-strip__item" (click)="pictureClick.emit(picture.url)">
        <img [src]="picture.url" [alt]="alt" (load)="updateArrows()" />
        <div class="picture-strip__item__zoom">
          <i class="bi bi-zoom-in"></i>
        </div>
      </div>
    }
  </div>

  @if (canScrollRight) {
    <button
      type="button"
      class="picture-strip__arrow picture-strip__arrow--right"
      (click)="scroll('right')"
      aria-label="Suivant"
    >
      <i class="bi bi-chevron-right"></i>
    </button>
  }
</div>
